import React from 'react';
import { Badge, Card, CardBody, Col, Row } from 'reactstrap';
import { getQuestionnaireByName } from '../../../../../apis/questionnaire';
import { getQuestionnaireResponseByReference } from '../../../../../apis/questionnaireResponse';
import { usePatient } from '../../../../../contexts/patient';
import { IQuestionnaire } from '../../../../../modules/unsw-fhir/Questionnaire';
import { IQuestionnaireResponse } from '../../../../../modules/unsw-fhir/QuestionnaireResponse';
import {
  isIntegerAnswerComponent,
  isQuestionnaireResponseItemAnswer,
} from '../../../../../modules/unsw-fhir/QuestionnaireResponse/typeGuards';
import { useDataApi } from '../../../../../modules/unsw-hooks';
const Field = ({ value, label }: { value: string; label: string }) => (
  <p className="align-middle mb-2">
    <strong>{label}: </strong>
    {value}
  </p>
);

const CristalFieldComponent = ({
  value,
  label,
}: {
  value: string;
  label: string;
}) => (
  <div className="align-middle mb-2">
    <strong>{label}: </strong>
    <h5 style={{ display: 'inline' }}>
      <Badge color="primary">{value}</Badge>
    </h5>
  </div>
);

const CristalField = () => {
  const { patient } = usePatient();

  const [{ data: questionnaire }] = useDataApi<IQuestionnaire | undefined>(
    getQuestionnaireByName,
    undefined,
    'cristal',
  );

  const [{ data: response }] = useDataApi<IQuestionnaireResponse | undefined>(
    getQuestionnaireResponseByReference,
    undefined,
    patient && patient.id,
    questionnaire && questionnaire.id,
  );
  let score = '-';
  if (response) {
    const item = response.item.find(i => i.linkId === '8-0');

    if (item && isQuestionnaireResponseItemAnswer(item)) {
      const answer = item.answer[0];
      score =
        answer && isIntegerAnswerComponent(answer)
          ? answer.valueInteger.toString()
          : '-';
    }
  }
  return <CristalFieldComponent label="CriSTAL" value={score} />;
};

const PatientInformationSectionComponent = ({
  displayName,
  birthDate,
  mrn,
}: {
  displayName: string;
  birthDate: string;
  mrn: string;
}) => (
  <Card>
    <CardBody>
      <Row noGutters>
        <Col>
          <Field value={displayName} label="Name" />
          <Field value={birthDate} label="Date of Birth" />
        </Col>
        <Col>
          <CristalField />
          <Field value={mrn} label="MRN" />
        </Col>
      </Row>
    </CardBody>
  </Card>
);

export default PatientInformationSectionComponent;
